<template>
  <component
    :is="errorWithDefaultImg ? 'div' : 'img'"
    :src="srcToUse"
    :key="srcToUse"
    @error="onError"
    :class="{
      '!object-contain': isDefaultFallback,
      shimmerElement: errorWithDefaultImg,
    }"
  />
</template>

<script>
import { defineComponent } from 'vue'
import defaultImg from './sample2.svg'
import { ImgUtils } from './imgUtils';

export default defineComponent({
  name: 'ImgComponent',
  props: {
    src: { type: String, default: "" },
    fallback: { type: String, default: '' },
    avatar: { type: [Boolean, String], default: false },
    defaultAvatarStyle: { type: String, default: '' },
  },
  data() {
    return {
      defaultImg,
      hasError: false,
      errorWithDefaultImg: false,
      triedReceivedFallback: false, // pour ne pas boucler sur fallback
    }
  },
  methods: {
    onError() {
      console.log("🚀 ~ this.hasError:", this.hasError)
      if (!this.hasError) {
        this.hasError = true
      } else if (this.fallback && !this.triedReceivedFallback) {
        this.triedReceivedFallback = true
      } else if (this.useFallback && this.srcToUse === this.defaultImg) {
        this.errorWithDefaultImg = true
        console.warn(
          `[ImgComponent] Fallback échoué, utilisation de l'image par défaut.`,
        )
      }
    },

    resolveSrc(rawSrc) {
      if (!rawSrc) return ''
      if (/^(https?:\/\/|data:image)/.test(rawSrc)) return rawSrc

      const bundled = ImgUtils.get(rawSrc)
      if (bundled) return bundled

      if (/^(\/|\.\/|\.\.\/)/.test(rawSrc)) return rawSrc

      console.warn(`[ImgComponent] Source inconnue: "${rawSrc}"`)
      return ''
    },
  },
  computed: {
    isDefaultFallback(){
      return this.srcToUse == defaultImg
    },
    useFallback() {
      return this.hasError
    },
    defaultAvatar() {
      let defaultStyle = this.defaultAvatarStyle
      try {
        if (!defaultStyle) {
          if (window.ImgComponentDefaultAvatarStyle)
            defaultStyle = window.ImgComponentDefaultAvatarStyle
        } else {
          window.ImgComponentDefaultAvatarStyle = defaultStyle
        }
      } catch (e) {}
      const avatarUrls = {
        avataaars:
          'https://api.dicebear.com/9.x/avataaars/svg?mouth=default,eating,grimace,serious,smile,twinkle,tongue',
        dylan: 'https://api.dicebear.com/9.x/dylan/svg?',
        miniavs: 'https://api.dicebear.com/9.x/miniavs/svg?',
        personas: 'https://api.dicebear.com/9.x/personas/svg?',
      }
      const baseUrl =
        avatarUrls[this.avatar] ||
        avatarUrls[defaultStyle] ||
        avatarUrls.avataaars
      return `${baseUrl}&seed=${this.src || Date.now()}.svg`
    },
    computedFallback() {
      // Priorité : prop fallback → avatar → defaultImg
      if (!this.triedReceivedFallback && this.fallback) return this.fallback
      return this.avatar ? this.defaultAvatar : this.defaultImg
    },
    srcToUse() {
      const base = this.useFallback ? this.computedFallback : this.src
      return this.resolveSrc(base)
    },
  },
  watch: {
    srcToUse: {
      immediate: true,
      handler(newVal) {
        this.$emit('pictureUrlSelected', newVal)
      },
    },
  },
})
</script>
